// export const BASE_API = "http://localhost:8080/api/v1";
export const BASE_API = "https://www.beasting.app/api/v1";
export const GA_TRACKING_ID = 'UA-137512462-2';
export const GA_COOKIE_DOMAIN = 'www.beasting.app';
